<template>
  <div class="card">
    <div class="top">
      <div class="t_left">
        <span @click="$emit('changeShowCard', 0)" class="active">{{ lang.overviewOfProgress }}</span>
        <span @click="$emit('changeShowCard', 1)" v-if="showCard!=-1">{{lang.difficultProblems}}</span>
        <span @click="$emit('changeShowCard', 2)" v-if="showCard!=-1">{{ lang.abilityStratification }}</span>
        <span @click="$emit('changeShowCard', 3)" v-if="showCard!=-1">{{lang.teachingSuggestions}}</span>
      </div>
      <div class="t_right" v-if="false">
        <img
          src="../../../../assets/img/teachingMode/changeUp.png"
          :style="{ cursor: showCard > 0 ? 'pointer' : 'not-allowed' }"
          @click="$emit('changeShowCard', 0)"
        />
        <img
          src="../../../../assets/img/teachingMode/changeDown.png"
          :style="{ cursor: showCard < 3 ? 'pointer' : 'not-allowed' }"
          @click="$emit('changeShowCard', 1)"
        />
      </div>
    </div>
    <div class="main">
      <div class="m_top">
        <!-- 对话人数 -->
        <div :style="exportBoolean ? `box-shadow:none` : ''">
          <div class="m_t_img">
            <img src="../../../../assets/img/teachingMode/dialogueNum.png" />
          </div>
          <div class="m_t_message">
            <div>{{ numTxt(cardData.overallData.dialogueNum) }}</div>
            <span>{{ lang.dialogueNumber }}</span>
          </div>
        </div>

        <!-- 对话次数 -->
        <div :style="exportBoolean ? `box-shadow:none` : ''">
          <div class="m_t_img">
            <img src="../../../../assets/img/teachingMode/chatNum.png" />
          </div>
          <div class="m_t_message">
            <div>{{ numTxt(cardData.overallData.chatNum) }}</div>
            <span>{{ lang.dialogueTimes }}</span>
          </div>
        </div>

        <!-- 总体完成率 -->
        <div :style="exportBoolean ? `box-shadow:none` : ''">
          <div class="m_t_img">
            <img src="../../../../assets/img/teachingMode/completionRate.png" />
          </div>
          <div class="m_t_message">
            <div>{{ cardData.overallData.completionRate }}</div>
            <span>{{ lang.totalCompletionRate }}</span>
          </div>
        </div>
      </div>

      <div class="m_center">
        <div class="m_line"></div>
        <div class="m_c_list">
          <div
            class="m_c_item"
            v-for="(item, index) in cardData.studentData"
            :key="index"
          >
            <div class="m_c_i_top">
              <span v-if="item.status == '0'">{{lang.notStarted}}</span>
              <span v-else-if="item.status == '1'">{{lang.inProgress}}</span>
              <span v-else>{{lang.completed}}</span>
            </div>
            <div
              class="m_c_i_bottom"
              v-if="item.user.length > 0"
              :style="exportBoolean ? `box-shadow:none` : ''"
            >
              <div class="m_c_i_b_top">
                <span>{{ item.user.length }}<span>{{ lang.people }}</span></span>
                <img
                  :class="{ m_ua_t_active: item.showAllUser }"
                  @click.stop="item.showAllUser = !item.showAllUser"
                  src="../../../../assets/img/teachingMode/u_arrow2.png"
                />
              </div>
              <div
                class="m_c_i_b_userList"
                :class="{ m_c_i_b_active: !item.showAllUser }"
              >
                <div
                  class="m_c_i_b_u_t_item"
                  v-for="(user, userIndex) in item.user"
                  :key="userIndex"
                >
                  <span>{{ user.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ol class="m_bottom">
        <li v-for="(item, index) in cardData.suggestion" :key="index">
          {{ item }}
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { myMixin } from "@/common/mixin";
export default {
  mixins: [myMixin],
  props: {
    analysisData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showCard: {
      type: Number,
      default: 0,
    },
    exportBoolean: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusList: [
        this.lang.unfinished,
        this.lang.completed,
        this.lang.pause,
        this.lang.stop,
      ],
    };
  },
  computed: {
    numTxt() {
      return (num) => {
        if (typeof num !== "number") return "";
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };
    },
    cardData() {
      let _result = {
        overallData: {
          dialogueNum: 0,
          chatNum: 0,
          completionRate: "0%",
        },
        studentData: [],
        suggestion: [],
      };

      if (this.analysisData && Object.keys(this.analysisData).length > 0) {
        _result = JSON.parse(JSON.stringify(this.analysisData));
      }

      return _result;
    },
  },
  methods: {
    generated(list) {
      return new Promise((resolve) => {
        let _result = {
          overallData: {
            dialogueNum: 0,
            chatNum: 0,
            completionRate: "0%",
          },
          studentData: [
            { status: "0", showAllUser: false, user: [] },
            { status: "1", showAllUser: false, user: [] },
            { status: "2", showAllUser: false, user: [] },
          ],
          suggestion: [],
        };

        if (!Array.isArray(list) || list.length <= 0) {
          return resolve(_result);
        }

        // 总数据
        _result.overallData.dialogueNum = list.length;
        _result.overallData.chatNum = list.reduce((cur, pre) => {
          return (
            cur +
            (Array.isArray(pre.nodeData)
              ? pre.nodeData.reduce((cur2, pre2) => {
                  return (
                    cur2 + (pre2.messageList ? pre2.messageList.length : 0)
                  );
                }, 0)
              : 0)
          );
        }, 0);

        _result.overallData.completionRate = `${(
          (list.filter((i) => i.status == "1").length / list.length) *
          100
        ).toFixed(0)}%`;

        // 学生完成情况
        list.forEach((i) => {
          let data = { name: i.name, summary: i.summary };

          if (i.nodeData.length <= 0) {
            _result.studentData[0].user.push(data);
          } else if (i.status != "1" && i.nodeData.length > 0) {
            _result.studentData[1].user.push(data);
          } else if (i.status == "1" && i.nodeData.length > 0) {
            _result.studentData[2].user.push(data);
          }
          // if (i.status == '0') {
          //   _result.studentData[0].user.push(data);
          // } else if (i.status == '1') {
          //   _result.studentData[1].user.push(data);
          // } else if (i.status == '2') {
          //   _result.studentData[2].user.push(data);
          // }
        });

        this.getAiData(list)
          .then((_suggestion) => {
            _result.suggestion = _suggestion;
            console.log(_result);
            resolve(_result);
          })
          .catch((err) => {
            console.log("_suggestionErr", err);
            resolve(_result);
          });
      });
    },
    getLang(){
      let lang = 'cn'
      if(this.lang.lang == 'cn'){
        lang = 'Chinese.'
      }else if(this.lang.lang == 'hk'){
        lang = 'Traditional Chinese.'
      }else if(this.lang.lang == 'en'){
        lang = 'English.'
      }
      return lang
    },
    getAiData(list, num = 0) {
      return new Promise((resolve) => {
        let _msg = ``;
        list.forEach((s) => {
          _msg += `学生：${s.name}\n总结：${s.summary}\n总节点数量：${
            s.stage
          }\n任务状态：${this.statusList[s.status]}\nID：${s.id}\n`;
          s.nodeData.forEach((n, nIndex) => {
            _msg += `【节点${(nIndex + 1).toString().padStart(2, "0")} ${
              n.messageList[0] ? n.messageList[0].aiName : "-"
            }】表情：${
              n.status == "0" ? "微笑" : n.status == "1" ? "不高兴" : "无表情"
            }\n`;
            n.messageList.forEach((m) => {
              _msg += `${m.userName}(${m.chatTime})：\n${m.userContent}\n${m.aiName}：\n${m.aiContent}\n`;
            });
          });
          _msg += "\n";
        });

        let _msg2 = `NOTICE
Role: 你是一个专业的学习数据分析师，需要基于学生在AI学习助手中的对话记录，分析学生的学习进度情况，识别主要的学习卡点和问题，为教师提供精准的教学洞察。
Language: Please use the same language as the user requirement, if the user speaks Chinese, the specific text of your answer should also be in Chinese.
ATTENTION: Use '##' to SPLIT SECTIONS, not '#'. Output format carefully referenced "Format example".
Instruction: Based on the context, follow "Format example", write content

#Context
## 任务
你需要重点关注：
1. 未完成学生卡在哪些具体节点，分析其原因
2. 学生在不同学习阶段遇到的困难类型和模式
3. 需要教师重点关注的学生及具体原因
4. 整体学习进度的异常模式、趋势或规律
5. 严格按照输出格式输出内容

# 输入信息
## 学生学习数据结构
${_msg}


# 输出格式

严格按照以下JSON格式输出：
["{针对性的教学建议1}","{针对性的教学建议2}","{针对性的教学建议3}"]

# 分析维度和方法

## 1. 学习进度卡点分析
- **节点转换分析**：识别学生从一个学习节点到下一个节点时遇到的困难
- **停滞模式识别**：分析学生在某个节点停留过久或反复出现问题的情况  
- **退出点分析**：识别学生最常放弃学习的节点和时机

## 2. 学习困难类型分类
通过分析学生的对话内容和行为模式，识别以下困难类型：
- **认知理解困难**：概念理解不清、逻辑思维困难、知识迁移困难
- **学习动机问题**：学习兴趣下降、畏难情绪、消极态度
- **操作技能困难**：具体操作不熟练、步骤混乱、方法错误
- **情绪调节问题**：焦虑、挫败、厌烦等负面情绪影响学习
- **交互沟通困难**：与AI交互不当、表达不清、理解偏差

## 3. 重点关注学生识别标准
- **学习表现异常**：进度明显落后、频繁出错、回答质量下降
- **情绪状态不良**：出现消极词汇、抗拒表达、情绪波动
- **参与度下降**：回答简短、互动减少、长时间无响应
- **困难反复出现**：同类问题多次出现、学习效果不佳

## 4. 进度洞察分析重点
- **整体趋势**：完成率变化、学习节奏、时间分布
- **共性问题**：多数学生遇到的相同困难
- **个体差异**：不同学生的学习模式和特点
- **成功模式**：表现优秀学生的共同特征

# 分析策略指导

## 文本分析关键词识别
**消极情绪指标**：
- 直接表达："不会"、"不懂"、"不想做"、"很烦"、"太难"
- 间接表现：回答过于简短、频繁重复、逃避问题

**学习困难指标**：
- 概念混淆、逻辑错误、前后矛盾
- 多次询问同类问题、理解偏差
- 操作步骤错误、方法运用不当

**积极表现指标**：
- 主动思考、深入分析、举一反三  
- 积极互动、详细回答、自我修正
- 创新思维、批判性思考、知识联系

## 进度异常判断标准
- **个体异常**：某学生的进度明显偏离同伴平均水平
- **群体异常**：某个节点的通过率异常偏低
- **时间异常**：学习时间分布不合理或停滞时间过长
- **质量异常**：完成进度正常但学习质量明显下降

# 其他提示
1. **基于事实分析，保持客观中性**：所有分析结论必须基于实际的对话数据，避免主观推测；使用专业术语，避免对学生进行负面标签化或价值判断；不仅识别问题，也要发现学生的优势和成功模式
2. **注重可操作性**：提供的洞察和建议应该具体可行，能指导教师采取实际行动；优先分析最新的学习状态和最近的变化趋势
3. **考虑个体差异**：认识到不同学生的学习方式、节奏和需求存在差异
4. **数据隐私保护**：在分析过程中保护学生隐私，使用适当的概括性描述
5. **完整性检查**：确保所有学生的学习状态都被纳入分析范围，无遗漏

基于提供的学生学习数据，运用上述分析框架生成专业的进度分析洞察报告。
`;

        let message = [{ role: "user", content: _msg2 }];

        this.chat_no_stream(message)
          .then((res) => {
            try {
              if (res) {
                res = res.replace(/^```json|```$/g, "").trim();
                let _group = JSON.parse(res);
                console.log(_group);
                resolve(_group);
              } else {
                // 若response为空视为catch流程
                if (num < 4) {
                  this.getAiData(list, num + 1).then(resolve);
                } else {
                  resolve([]);
                }
              }
            } catch (error) {
              // 若解析失败则重试，最多5次（num从0 ~ 4）
              if (num < 4) {
                this.getAiData(list, num + 1).then(resolve);
              } else {
                resolve([]);
              }
            }
          })
          .catch(() => {
            // catch异常也重试，最多5次
            if (num < 4) {
              this.getAiData(list, num + 1).then(resolve);
            } else {
              resolve([]);
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  height: auto;
  border: 1px solid rgba(245, 248, 255, 0.25);
  box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 16px 24px 2px rgba(0, 0, 0, 0.04);
  box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(16.700000762939453px);
  border-radius: 12px;
  box-sizing: border-box;
  gap: 20px;
  .top {
    width: 100%;
    height: 50px;
    background: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    .t_left {
      white-space: nowrap;
      display: flex;
      gap: 20px;
      & > span {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #797979;
        cursor: pointer;
      }
      &>.active{
        font-size: 18px;
        color: #000;
      }
    }
    .t_right {
      display: flex;
      gap: 20px;
      & > img {
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
    }
  }
  .main {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 20px;
    background: #fafafa;
    .m_top {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      & > div {
        width: 100%;
        height: 100px;
        background: rgba(0, 82, 217, 1);
        box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.05);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        .m_t_img {
          height: 40px;
          width: 40px;
          background: rgba(255, 255, 255, 0.7);
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          & > img {
            width: 22px;
            height: 22px;
            object-fit: cover;
          }
        }
        .m_t_message {
          width: auto;
          height: auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          gap: 10px;
          & > div {
            font-weight: 600;
            font-size: 26px;
            line-height: 100%;
            color: rgba(255, 255, 255, 1);
          }
          & > span {
            font-weight: 600;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
    .m_center {
      width: 100%;
      height: auto;
      border-top: 1px solid rgba(150, 155, 163, 0.2);
      border-bottom: 1px solid rgba(150, 155, 163, 0.2);
      margin: 20px 0;
      box-sizing: border-box;
      padding: 20px 0;
      position: relative;
      .m_line {
        width: 100%;
        height: 2px;
        position: relative;
        //position: absolute;
        //top: calc(20px + 20px - 1.5px);
        border-bottom: 3px dashed rgba(0, 82, 217, 1);
        //display: flex;
        //align-items: center;
        // z-index: 1;
        margin-bottom: -21px;
        &::after {
          content: "";
          width: 16px;
          height: 16px;
          background: rgba(0, 82, 217, 1);
          border-radius: 50%;
          position: absolute;
          left: 0;
          top: 100%;
          transform: translateY(-40%);
        }
        &::before {
          content: "";
          width: 16px;
          height: 16px;
          background: rgba(0, 82, 217, 1);
          border-radius: 50%;
          position: absolute;
          right: 0;
          top: 100%;
          transform: translateY(-40%);
        }
      }
      .m_c_list {
        width: 100%;
        height: auto;
        display: grid;
        gap: 20px;
        grid-template-columns: repeat(3, 1fr);
        position: relative;
        .m_c_item {
          width: 100%;
          height: auto;
          .m_c_i_top {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            & > span {
              background: rgba(250, 250, 250, 1);
              color: #0052d9;
              padding: 6px 15px;
              border: 1px dashed rgba(0, 82, 217, 1);
              border-radius: 26px;
              font-size: 14px;
              display: block;
              // z-index: 2;
            }
          }
          .m_c_i_bottom {
            margin-top: 20px;
            width: 100%;
            height: auto;
            box-sizing: border-box;
            padding: 12px 16px;
            border-radius: 8px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.05);
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
            .m_c_i_b_top {
              width: 100%;
              height: auto;
              display: flex;
              align-items: center;
              justify-content: space-between;
              & > span {
                font-weight: 600;
                font-size: 22px;
                line-height: 28px;
                color: rgba(34, 34, 34, 1);
                display: flex;
                align-items: center;

                & > span {
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 20px;
                  // letter-spacing: 18px;
                  color: rgba(34, 34, 34, 1);
                  margin-left: 10px;
                }
              }
              & > img {
                width: 16px;
                height: 16px;
                transform: rotate(0deg);
                transition: 0.3s;
                cursor: pointer;
                &.m_ua_t_active {
                  transform: rotate(180deg);
                }
              }
            }
            .m_c_i_b_userList {
              width: 100%;
              height: auto;
              display: flex;
              flex-wrap: wrap;
              overflow: hidden;
              gap: 10px;
              margin-top: 15px;
              .m_c_i_b_u_t_item {
                padding: 2px 8px;
                border-radius: 100px;
                background: rgba(0, 0, 0, 0.06);
                color: rgba(34, 34, 34, 1);
                font-size: 14px;
                font-weight: 500;
                //cursor: pointer;
                //transition: 0.2s;
                // &:hover {
                //   background: rgba(209, 225, 255, 0.6);
                //   color: rgba(5, 96, 253, 1);
                // }
              }
            }
            .m_c_i_b_active {
              height: 24px;
            }
          }
        }
      }
    }
    .m_bottom {
      width: 100%;
      height: auto;
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      gap: 15px;
      list-style: disc inside;
      /* 无序列表样式 */
      & > li {
        display: list-item;
        list-style: disc inside;
        width: 100%;
        font-size: 14px;
        color: rgba(0, 0, 0, 1);
      }
    }
  }
}
</style>
